export default class AssetService {
  static ImageRoot = './images/';

  image(rel_path: string): string {
    return AssetService.ImageRoot + rel_path + ' ';
  }
  imageAttr(rel_path: string): string {
    return ' src="' + this.image(rel_path) + '" ';
  }
  static readonly predictLink = '/members/forecast-toolboxes.php';
}
